import { useRequest } from 'ahooks'
import { Form, Modal } from 'antd'
import { keyBy, mapValues } from 'lodash'
import React from 'react'

import { JQLTableConfig } from '@/components/jql/jql-table-config.component'
import { JiraTableColumnType, ResourceType } from '@/schemas'

export interface JiraColumnProps {
  id: number
  type: JiraTableColumnType
  key: string
  isSelected: boolean
}

interface DevlopJQLTableConfigProps {
  columns: JiraColumnProps[]
  selfId: string
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  refresh: () => Promise<JiraColumnProps[]>
  hasBugField?: boolean
  hasReleaseStatusField?: boolean
}

export const DevlopJqlTableConfig: React.FC<DevlopJQLTableConfigProps> = ({
  columns,
  selfId,
  visible,
  setVisible,
  refresh,
  hasBugField = true,
  hasReleaseStatusField = true,
}) => {
  const [form] = Form.useForm()

  const { run, loading } = useRequest(
    (columns) => ({
      url: '/api/project/updateJiraTableConfig',
      method: 'post',
      data: {
        selfId,
        type: ResourceType.DEVLOP,
        columns,
      },
    }),
    {
      manual: true,
      onSuccess() {
        refresh()
      },
    }
  )

  const onOk = async () => {
    const value = await form.validateFields()
    const columns = Object.keys(value)
      .map((key) => ({
        key,
        isSelected: !!value[key],
      }))
      .filter((col) => col.isSelected)
    await run(columns)
    setVisible(false)
  }

  React.useEffect(() => {
    if (visible && columns) {
      form.setFieldsValue(mapValues(keyBy(columns, 'key'), 'isSelected'))
    }
  }, [columns, visible])

  if (!columns) {
    return null
  }

  return (
    <Modal visible={visible} confirmLoading={loading} onCancel={() => setVisible(false)} destroyOnClose onOk={onOk}>
      <JQLTableConfig
        hasBugField={hasBugField}
        hasReleaseStatusField={hasReleaseStatusField}
        form={form}
        columns={columns}
      />
    </Modal>
  )
}
